.transaction-list {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  z-index: 9999;
}
@media (min-width: 760px) {
  .transaction-list {
    right: 2rem;
    bottom: 2rem;
    width: 22.5rem;
    left: auto;
  }
}
